module.exports = __webpack_public_path__ + "static/media/mulher_r1_c4.3497d186.jpg";